import React from "react";

import Table from "../../../common/Table";

import { Link } from "react-router-dom";
import RowPhoto from "../../../common/TdImg";

const BenefitTeachersList = ({ data, query }) => {

  const renderLink = (e) => {
    return (
        <Link to={`/mis/teachers/${e.teacher_id}/profile/benefit?teacherName=${e.teacher_name}`}>
          {e.teacher_name}
        </Link>
    );
  };

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "teacher_photo",
      label: "عکس",
      content: ({ teacher_photo }) => <RowPhoto src={teacher_photo} />,
    },
    {
      path: "aria_id",
      label: "کد استاد",
    },
    {
      path: "teacher_name",
      label: "استاد",
      content: (e) => renderLink(e)
    },
    { path: "benefit", label: "امتیاز" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default BenefitTeachersList;
